const initialState = {
    view: "Dashboard",
};

export const setView = (view: string) => ({
    type: "SET_VIEW",
    payload: view,
});

export const uiReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case "SET_VIEW":
            return { ...state, view: action.payload };
        default:
            return state;
    }
};